import { ChatMessageType } from "src/utils/enums/ChatMessageTypeEnum";
import { JobPostHiringTypeEnum } from "../job/Job";
import { NewJobPost } from "../job/NewJobPost";
import { UpdateApplicationStagesBody } from "../job/Job.store";

export interface MassHiringStoreInferface {
    jobId: string;
    isLoadingList: boolean;
    showNewJobPostTypeModal: boolean;
    newJobPostType: JobPostHiringTypeEnum;
    newJobPostMenuStep: NewJobPostMenuStepEnum;
    newJobPostData: NewJobPost | null;
    newJobPostRecruitmentStages: UpdateApplicationStagesBody | null;
    isLoadingMhMenuButton: boolean;
    triggerSaveJobPost: boolean;
    triggerSaveRecruitmentStages: boolean;
    triggerSaveRecruitmentStagesInManageJob: boolean;
    triggerSaveSaudConfiguration: boolean;
    triggerSaveScreeningQuestions: boolean;
    isSidebarVisible: boolean;
    applicantsView: ApplicantsViewEnum;
    isRejectedTabActive: boolean;
    showSearchApplicantsInput: boolean;
    showFilterApplicantsModal: boolean;
    showRejectApplicantModal: boolean;
    rejectApplicantModalIsBulk: boolean;
    showArchiveJobModal: boolean;
    showVideoInterviewModal: boolean;
    videoInterviewUrl: string;
    showApplyChangesToLocationsModal: boolean;
    triggerRedirectToApplicantsList: boolean;
}

export enum NewJobPostMenuStepEnum {
    MASTER_JOB_INFO = 'MASTER_JOB_INFO',
    SAUD_CONFIGURATION = 'SAUD_CONFIGURATION',
    SCREENING_QUESTIONS = 'SCREENING_QUESTIONS',
    RECRUITMENT_STAGES = 'RECRUITMENT_STAGES',
    ONBOARDING = 'ONBOARDING',
}

export enum ApplicantsViewEnum {
    TABLE = 'TABLE',
    CARD = 'CARD',
}

export enum MhTabsEnum {
    APPLICANTS = 'APPLICANTS',
    LOCATIONS = 'LOCATIONS',
    ONBOARDING = 'ONBOARDING',
}

export enum ApplicantRejectionReasonEnum {
    FAR_FROM_LOCATION = 'FAR_FROM_LOCATION',
    NOT_FIT = 'NOT_FIT',
    OVERPRICED = 'OVERPRICED',
    HIRED_ELSEWHERE = 'HIRED_ELSEWHERE',
}

export interface BulkMessageRequest {
    jobId: string;
    applicationIds?: string[];
    offlineApplicationIds?: string[];
    workerIds?: string[];
    onlinePeers?: string[];
    msgs: { msg: string; msgType: ChatMessageType }[];
    templateId?: string;
}

